import { NgModule, ModuleWithProviders, inject, provideAppInitializer } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BackenAccessService } from '../shared/backend-access.service';
import { DownloadService } from '../download.service';
import { LessonsFilterService } from '../content/lessons-filter-service';
import { LoaderService } from './services/loader/loader.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoaderInterceptor } from './services/loader/loader.interceptor';
import { CachingInterceptor } from './services/cache/caching.interceptor';
import { RequestCacheWithMap } from './services/cache/request-cache.service';
import { MessageService } from './services/message.service';
import { NotificationService } from './services/notification/notification.service';
import { RequestInterceptor } from './services/request/request.interceptor';
import { StateInterceptor } from './services/cache/state.interceptor';
import { SeriesService } from '../series/series.service';
import { ErrorsModule } from './errors/errors.module';
import { RateLimitInterceptor } from './errors/rate-limit-interceptor/rate-limit.interceptor';
import { ConvertLayoutService } from './services/convertLayout/convert-layout.service';
import { UtilService } from './services/util/util.service';
import { MatchMediaService } from './services/match-media/match-media.service';
import { BtnLinkService } from '../shared/helpers/btn-link/btn-link.service';
import { ContentBoxService } from '../shared/content/content-box.service';
import { SideNavService } from '../shared/side-nav/side-nav.service';
import { SocialShareService } from '../shared/social-share/social-share.service';
import { WindowRefService } from './services/window-ref/window-ref.service';
import { FilterBoxService } from '../shared/filter/filter-box.service';
import { RavService } from '../ravs/rav.service';
import { UrlAddressService } from './services/url-address/url-address.service';
import { MetaTagService } from './services/meta-tag/meta-tag.service';
import { I18nService } from './services/i18n/i18n.service';
import { CookieService } from 'ngx-cookie-service';
// import { AngularVersionInterceptor } from "./services/angular-version/angular-version.interceptor";
import { NihulClientVersionInterceptor } from './services/nihul-client-version/nihul-client-version.interceptor';
import { BreakPointSizeService } from './services/break-point-size/break-point-size.service';
import { IconsService } from './services/icons.service';
// import { AdditionalContentService } from "./additional-content/additional-content.service";

@NgModule({
    imports: [ErrorsModule],
    exports: [ErrorsModule],
    providers: [
        Title,
        UrlAddressService,
        I18nService,
        MetaTagService,
        BackenAccessService,
        DownloadService,
        //TODO: LessonsFilterService needs to be provided inside ContentAreaModule but that create problem in other services
        LessonsFilterService,
        RavService,
        SeriesService,
        ConvertLayoutService,
        UtilService,
        MatchMediaService,
        BtnLinkService,
        ContentBoxService,
        SideNavService,
        SocialShareService,
        WindowRefService,
        FilterBoxService,
        BreakPointSizeService,
        CookieService,
        provideAppInitializer(() => inject(IconsService).registerIcons()),
        // AdditionalContentService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RequestInterceptor,
            multi: true,
        },
        // {
        //     provide: HTTP_INTERCEPTORS,
        //     useClass: AngularVersionInterceptor,
        //     multi: true
        // },
        {
            //the cms-api build-version header - the save endpoints refuse critically-stale
            //clients by it (server-side enforcement of the nihul version watch)
            provide: HTTP_INTERCEPTORS,
            useClass: NihulClientVersionInterceptor,
            multi: true,
        },
        LoaderService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoaderInterceptor,
            multi: true,
        },
        MessageService,
        NotificationService,
        RequestCacheWithMap,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CachingInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: StateInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RateLimitInterceptor,
            multi: true,
        },
    ],
})
export class CoreModule {
    constructor() {
        const parentModule = inject(CoreModule, { optional: true, skipSelf: true })!;

        if (parentModule) {
            throw new Error('CoreModule is already loaded. Import it in the AppModule only');
        }
    }

    static forRoot(): ModuleWithProviders<CoreModule> {
        return {
            ngModule: CoreModule,
        };
    }
}
